module.exports = __webpack_public_path__ + "images/emoji/warning.3829ddb33857dc99c531.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/warning.png
// module id = UsRC
// module chunks = 13